import { treeViewReducerKey } from './TreeViewConstants';

export function treeView(state) {
  return state.get(treeViewReducerKey);
}

export function taxonomies(state) {
  return treeView(state).get('taxonomies');
}

export function selectedTaxonomies(state) {
  return treeView(state).get('selectedTaxonomies');
}

export function selectedListExpanded(state) {
  return treeView(state).get('selectedListExpanded');
}

export function initialConfig(state) {
  return treeView(state).get('initialConfig');
}

export function selectionOrder(state) {
  return treeView(state).get('selectionOrder');
}
